import { render, staticRenderFns } from "./index.vue?vue&type=template&id=20ac17ca&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ac17ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ac17ca')) {
      api.createRecord('20ac17ca', component.options)
    } else {
      api.reload('20ac17ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=20ac17ca&scoped=true&", function () {
      api.rerender('20ac17ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/news/newsList/index.vue"
export default component.exports